import { render } from "./LoginIndex.vue?vue&type=template&id=f1c56ba8"
import script from "./LoginIndex.vue?vue&type=script&lang=js"
export * from "./LoginIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__